<template>
	<c-dialog ref="dialog" mode="slide" width="50vw" :button="false">
		<div class="m-log-content">
			<div v-if="productInfo || productCode" class="m-log-head">
				<span v-if="productInfo">{{productInfo}}</span>
				<span v-if="productCode" class="m-log-code">背贴码：{{productCode}}</span>
			</div>
			<c-title>改价记录</c-title>
			<c-table ref="list" border :paging="false">
				<c-table-column label="操作时间" name="create_date" width="130"></c-table-column>
				<c-table-column label="操作人" name="operator_name" width="70"></c-table-column>
				<c-table-column label="调整前金额" width="110">
					<template #default="{data}">
						{{formatPrice(data.before_price)}}
					</template>
				</c-table-column>
				<c-table-column label="调整后金额" width="110">
					<template #default="{data}">
						{{formatPrice(data.after_price)}}
					</template>
				</c-table-column>
				<c-table-column label="渠道" name="channel_name"></c-table-column>
			</c-table>
		</div>
	</c-dialog>
</template>

<script>
	export default {
		name: 'salePriceLog',

		data() {
			return {
				productInfo: '',
				/**背贴码：列表行带入，与商品名一并展示*/
				productCode: ''
			}
		},

		methods: {
			/*********打开弹框**********/
			open(data) {
				this.productInfo = data.product_info || '';
				this.productCode = data.produce_unique_code || '';
				this.$refs.dialog.open({title: '改价记录'});
				this.$nextTick(() => {
					this.$refs.list.load({
						url: '/sale/product/priceLog/list',
						data: {
							sale_product_id: data.id
						}
					});
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-log-content {
		padding: 20px;
	}

	.m-log-head {
		padding: 10px 0 16px;
		font-size: 18px;
		font-weight: 600;
		color: #333;
		text-align: center;

		/*背贴码单独一行展示，不与商品名挤在同一行；与商品名行拉开行距*/
		.m-log-code {
			display: block;
			margin-top: 8px;
			line-height: 1.4;
			font-size: 14px;
			font-weight: normal;
			color: #666;
		}
	}
</style>
